const THEME_KEY = "CRICFEED_THEME";
const preferredColorScheme = "(prefers-color-scheme: dark)";

export { THEME_KEY, preferredColorScheme };
